import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Card, Grid, Typography } from "@mui/material";
import CircularLoader from "../../components/circularLoader";
import Label from "../../components/Label";
import { parseDate } from "../../utils/tableFunctions";
import { getMerchantPayoutDetails } from "../../services/services"; 

const MerchantPayoutDetailsCard = ({ itemId, userRole }) => {
    const [details, setDetails] = useState(null);
    const [loaded, setLoaded] = useState(false);
    const params = useParams();

    const merchantId = params.merchantId ?? params.id ?? itemId;

    useEffect(() => {
        if (merchantId) getMerchantPayoutDetails(merchantId, setDetails, setLoaded);
    }, [merchantId]);

    if (!loaded) {
        return <CircularLoader />;
    }

    if (!details) {
        return (
            <Container>
                <Typography variant="h6" color="error">
                    Failed to load Merchant Payout details
                </Typography>
            </Container>
        );
    }

    const fields = [
        { label: "Merchant ID", value: details.merchant_id },
        { label: "Merchant Name", value: details.merchant_name },
        { label: "Source", value: details.source },
        { label: "Account Number", value: details.account_number },
        { label: "Account Name", value: details.account_name },
        { label: "Is Registered in Singapore", value: details.is_registered_singapore, type: "boolean" },
        { label: "Registered Country", value: details.registered_country },
        { label: "Created At", value: details.created_at ? parseDate(details.created_at) : null },
        { label: "Updated At", value: details.updated_at ? parseDate(details.updated_at) : null },
    ];

    const mid = Math.ceil(fields.length / 2);
    const leftFields = fields.slice(0, mid);
    const rightFields = fields.slice(mid);

    const renderRow = (field, idx) => {
        const { label, value, type } = field;
        const display =
            type === "boolean" ? (
                <Label variant="ghost" color={value ? "success" : "error"}>
                    {value ? "YES" : "NO"}
                </Label>
            ) : value !== null && value !== undefined && value !== "" ? (
                value
            ) : (
                "N/A"
            );

        return (
            <Grid item xs={12} key={idx}>
                <Grid container alignItems="center" spacing={1}>
                    <Grid item xs={5}>
                        <Typography variant="subtitle1">{label}</Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography variant="body1" component="div">
                            {display}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <Container>
            {/* Header */}
            <Typography variant="h4" gutterBottom>
                Merchant Payout Details
            </Typography>

            <Card sx={{ p: 3, mb: 3 }}>
                <Grid container spacing={2}>
                    {/* Left column */}
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                            {leftFields.map((f, i) => renderRow(f, i))}
                        </Grid>
                    </Grid>

                    {/* Right column */}
                    <Grid item xs={12} md={6}>
                        <Grid container spacing={2}>
                            {rightFields.map((f, i) => renderRow(f, i + mid))}
                        </Grid>
                    </Grid>
                </Grid>
            </Card>
        </Container>
    );
};

export default MerchantPayoutDetailsCard;